import { render, staticRenderFns } from "./8.vue?vue&type=template&id=c92c8f32&scoped=true"
var script = {}
import style0 from "./8.vue?vue&type=style&index=0&id=c92c8f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92c8f32",
  null
  
)

export default component.exports